const NOT_EMPTY = "Field cannot be empty.";
const EMAIL = "Email has to be valid!";
const PASSWORD = "Password has to have at least 8 characters!";
const LINK = "Field must be valid URL address.";
const MIN_THREE_CHARACTERS = "You must enter at least 3 characters.";

export { NOT_EMPTY, EMAIL, PASSWORD, LINK, MIN_THREE_CHARACTERS };
